import React from "react";

function SvgIcMapPoi107(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M16 24.003h-.016l.512-1.988c1.324-.59 4.483-2.082 5.275-6.052 1.164-5.844-2.741-10.936-2.741-10.936s-5.699 3.528-6.863 9.372c-.648 3.25 1.024 5.365 1.897 6.603.043-.24 2.426-10.73 2.48-11 .241-1.214 1.447-1 1.447-1l-3.016 15.015C10.488 24.13 7 24.976 7 26.003h18c0-1.105-4.029-2-9-2"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi107;
